import React, { Fragment, useContext } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@emotion/react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { ThemeContext } from '../theme';
import {
  DRAWER_MASK_ZINDEX,
  DRAWER_ZINDEX
} from '../utils';

const propTypes = {
  showMask: PropTypes.bool,
  maskOpacity: PropTypes.string,
  placement: PropTypes.oneOf(['left', 'right', 'top', 'down']),
  width: PropTypes.number,
  height: PropTypes.number,
  visible: PropTypes.bool,
  zIndex: PropTypes.string,
  disableMaskClick: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  toggleDrawer: PropTypes.func,
  className: PropTypes.string
};

const defaultProps = {
  showMask: true,
  maskOpacity: '0.8',
  placement: 'right',
  disableMaskClick: false,
  width: 256,
  height: 256,
  className: ''
};

const Drawer = (props) => {
  const context = useContext(ThemeContext);
  const theme = useTheme();
  // const { theme } = context;
  // const { drawer } = theme;
  let drawer;
  if (theme && theme.drawer) {
    drawer = theme.drawer;
  } else {
    drawer = context.theme.drawer;
  }
  const { showMask, visible, toggleDrawer, placement, width, maskOpacity } = props;

  const styles = StyleSheet.create({
    mask: {
      ...drawer.maskProps,
      position: 'fixed',
      top: '0',
      left: '0',
      height: '100vh',
      width: '100vw',
      opacity: maskOpacity,
      zIndex: props.zIndex ? `${parseInt(props.zIndex) - 50}` : DRAWER_MASK_ZINDEX
    },
    drawer: {
      ...drawer.props,
      zIndex: props.zIndex ? props.zIndex : DRAWER_ZINDEX,
      position: 'fixed',
      transition: '0.3s',
      overflowY: 'scroll',
      // height: '100vh',
      // height: props.height ? `${props.height}px` : '100%',
      height: '100%',
      width: `${width}px`,
      border: 'none',
      overscrollBehavior: 'contain'
      // boxShadow: '-6px 0 16px -8px rgba(0, 0, 0, 0.08), -9px 0 28px 0 rgba(0, 0, 0, 0.05), -12px 0 48px 16px rgba(0, 0, 0, 0.03)'
    },
    right: {
      right: '0',
      top: '0',
      borderLeft: '1px solid'
    },
    left: {
      left: '0',
      top: '0',
      borderRight: '1px solid'
    },
    top: {
      left: '0',
      top: '0',
      borderBottom: '1px solid'
    },
    bottom: {
      left: '0',
      bottom: '0',
      borderTop: '1px solid'
    },
    hideRight: {
      transform: 'translateX(100%)'
    },
    hideLeft: {
      transform: 'translateX(-100%)'
    },
    hideTop: {
      transform: 'translateY(-100%)'
    },
    hideBottom: {
      transform: 'translateY(100%)'
    }
  });

  return (
    <>
      {/* Drawer mask */}
      {showMask && visible &&
        <div
          className={css(styles.mask)}
          onClick={() => {
            if (!props.disableMaskClick) {
              toggleDrawer();
            }
          }}
        />
      }

      {/* Drawer */}
      <div
        style={{ ...props.style }}
        className={`${props.className} ${css(
          styles.drawer,
          placement === 'right' && styles.right,
          !visible && placement === 'right' && styles.hideRight,
          placement === 'left' && styles.left,
          !visible && placement === 'left' && styles.hideLeft,
          placement === 'top' && styles.top,
          !visible && placement === 'top' && styles.hideTop,
          placement === 'bottom' && styles.bottom,
          !visible && placement === 'bottom' && styles.hideBottom
        )}`}
      >
        <Fragment>
          {props.children}
        </Fragment>
      </div>
    </>
  );
};

Drawer.propTypes = propTypes;
Drawer.defaultProps = defaultProps;

export { Drawer };
